<template>
  <PassthroughLogo
    v-if="logo"
    :logo="logo"
    class="app-logo"
    :class="$attrs.class"
  />
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    logo() {
      if (this.light) {
        return window.Nova.config('lightLogo')
      }

      return window.Nova.config('logo')
    },
  },
}
</script>

<style scoped>
::v-deep(.app-logo) {
  max-width: 100%;
}
</style>
